import {defineStore} from "pinia";
import type {OutputNotification} from "~/models";

export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        notifications: [] as OutputNotification[],
        unread: 0 as number,
    }),
    actions: {
        async load() {
            const data = await useApi().getNotificationsRaw()
            this.notifications = await data.value() as OutputNotification[]
            this.unread = Number(data.raw.headers.get('x-unread-items') || 0)

            let exp: null|number = null;
            let curTime = new Date().getTime();
            this.notifications.forEach(notification => {
                let tempExp = new Date(notification.expiresAt).getTime()
                if ((!exp || tempExp < exp) && tempExp > curTime) {
                    exp = tempExp
                }
            })

            if (exp !== null && exp !== curTime) {
                let refreshTime = exp - curTime;
                refreshTime = refreshTime < 60000 ? 60000 : refreshTime;
                setTimeout(async () => {
                    await this.load()
                }, refreshTime);
            }
        },
        markRead(id: number) {
            this.unread = 0
            this.notifications.forEach(notification => {
                if (notification.id === id) {
                    notification.read = true
                }
                this.unread += notification.read ? 0 : 1
            })
        },
    },
})